import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { folder, id } from "@planzone/dto";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  { folder }: Boundaries["uploadDocument"]["request"],
): State {
  const index = state.findIndex((req) => req.folder.uuid === folder.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { folder, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { folder }: Boundaries["uploadDocument"]["success"],
): State {
  const index = state.findIndex((req) => req.folder.uuid === folder.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { folder, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { folder, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { folder }: Boundaries["uploadDocument"]["failure"],
): State {
  const index = state.findIndex((req) => req.folder.uuid === folder.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { folder, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.uploadDocumentRequested]: handleRequest,
    [events.uploadDocumentSucceeded]: handleSuccess,
    [events.uploadDocumentFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
